import Background1 from './background1.png';
import Background1Webp from './background1.webp';
import Background2 from './background2.png';
import Background2Webp from './background2.webp';
import Background3 from './background3.png';
import Background3Webp from './background3.webp';
import MobileBackground1 from './mobileBackground1.svg';
import MobileBackground1Webp from './mobileBackground1.webp';
import MobileBackground2 from './mobileBackground2.svg';
import MobileBackground2Webp from './mobileBackground2.webp';
import MobileBackground3 from './mobileBackground3.svg';
import MobileBackground3Webp from './mobileBackground3.webp';
import PlumbersIcon from './plumbers.svg';
import BuildersIcon from './builders.svg';
import MechanicsIcon from './mechanics.svg';
import DentistIcon from './dentist.svg';
import MassageIcon from './massage.svg';
import CleanersIcon from './cleaners.svg';
import HairdressersIcon from './hairdressers.svg';
import DevicesGraphic from './devices.png';
import DevicesGraphicWebp from './devices.webp';
import QuotesBackground from './quotesBackground.svg';
import QuotesBackgroundWebp from './quotesBackground.webp';
import QuotesBackgroundMobile from './quotesBackgroundMobile.png';
import QuotesBackgroundMobileWebp from './quotesBackgroundMobile.webp';
import WaveBackground from './waveBackground.png';
import WaveBackgroundWebp from './waveBackground.webp';
import LocalBusinessInfoGraphic from './localBusinessGraphic.png';
import LocalBusinessInfoGraphicWebp from './localBusinessGraphic.webp';
import LocalBusinessInfoHomeGraphic from './localBusinessHomeGraphic.jpg';
import LocalBusinessInfoHomeGraphicWebp from './localBusinessHomeGraphic.webp';
import LocalBusinessInfoCheck from './localBusinessCheck.svg';
import FeaturedReviewsBackgroundWebp from './featuredReviewsBackground.webp';
import FeaturedReviewsBackground from './featuredReviewsBackground.svg';
import OwnLocalBusinessGraphicWebp from './ownLocalBusiness.webp';
import OwnLocalBusinessGraphic from './ownLocalBusiness.png';
import ListYourBusinessGraphic from './listYourBusinessGraphic.svg';
import ListYourBusinessGraphicWebp from './listYourBusinessGraphic.webp';
import ReasonsListBusinessGraphic from './reasonsListBusiness.png';
import ReasonsListBusinessGraphicWebp from './reasonsListBusiness.webp';
import ListYourBusinessGraphicMobile from './listYourBusinessGraphicMobile.png';
import ListYourBusinessGraphicMobileWebp from './listYourBusinessGraphicMobile.webp';
import HomeBannerDark from './homeBannerDark.jpg';
import HomeBannerDarkWebp from './homeBannerDark.webp';
import HomeBannerDarkMobile from './homeBannerDarkMobile.png';
import HomeBannerDarkMobileWebp from './homeBannerDarkMobile.webp';
import HomeBannerLight from './homeBannerLight.jpg';
import HomeBannerLightWebp from './homeBannerLight.webp';
import HomeBannerLightMobile from './homeBannerLightMobile.png';
import HomeBannerLightMobileWebp from './homeBannerLightMobile.webp';

export {
  HomeBannerDark,
  HomeBannerDarkWebp,
  HomeBannerLight,
  HomeBannerLightWebp,
  HomeBannerDarkMobile,
  HomeBannerDarkMobileWebp,
  HomeBannerLightMobile,
  HomeBannerLightMobileWebp,
  Background1,
  Background1Webp,
  Background2,
  Background2Webp,
  Background3,
  Background3Webp,
  MobileBackground1,
  MobileBackground1Webp,
  MobileBackground2,
  MobileBackground2Webp,
  MobileBackground3,
  MobileBackground3Webp,
  PlumbersIcon,
  BuildersIcon,
  MechanicsIcon,
  DentistIcon,
  MassageIcon,
  CleanersIcon,
  HairdressersIcon,
  DevicesGraphic,
  DevicesGraphicWebp,
  QuotesBackground,
  QuotesBackgroundWebp,
  QuotesBackgroundMobile,
  QuotesBackgroundMobileWebp,
  WaveBackground,
  WaveBackgroundWebp,
  LocalBusinessInfoGraphic,
  LocalBusinessInfoGraphicWebp,
  LocalBusinessInfoCheck,
  LocalBusinessInfoHomeGraphic,
  LocalBusinessInfoHomeGraphicWebp,
  FeaturedReviewsBackgroundWebp,
  FeaturedReviewsBackground,
  OwnLocalBusinessGraphicWebp,
  OwnLocalBusinessGraphic,
  ListYourBusinessGraphic,
  ListYourBusinessGraphicWebp,
  ReasonsListBusinessGraphic,
  ReasonsListBusinessGraphicWebp,
  ListYourBusinessGraphicMobile,
  ListYourBusinessGraphicMobileWebp,
};
